import { OrganizationSettingsCards } from "@daveyplate/better-auth-ui";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/organization/settings")({
  component: RouteComponent,
});

function RouteComponent() {
  return <OrganizationSettingsCards />;
}
